import e from"react";import{SvgIcon as t}from"../SvgIcon.js";const r=r=>e.createElement(t,{...r},e.createElement("path",{d:"M13.7649 10.6185H10.635v3.1382H9.38133v-3.1382H6.2514V9.37318h3.12993V6.24326H10.635v3.12992h3.1299v1.24532Z"}));export{r as PlusMath};
//# sourceMappingURL=PlusMath.js.map
